import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import styles from './search.module.scss';

export default function Search({
  handleChangeFilters,
  search,
}:{
  handleChangeFilters: (obj: any) => void,
  search: string,
}) {
  const [inputSearch, setInputSearch] = useState<string>(search || '');
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [searchIsOpen, setSearchIsOpen] = useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newText = event.target.value;
    setInputSearch(newText);
    setIsSaving(true);
  };

  const clearSearch = () => {
    setSearchIsOpen(false);
    setInputSearch('');
    if (search) {
      handleChangeFilters({
        page: 0,
        search: '',
      });
    }
  };

  useEffect(() => {
    const saveTimeout = setTimeout(() => {
      if (isSaving) {
        // Perform your save action here (e.g., an API call)
        handleChangeFilters({
          page: 0,
          search: inputSearch,
        });
        setIsSaving(false);
      }
    }, 1000);

    return () => clearTimeout(saveTimeout);
  }, [inputSearch, isSaving]);

  useEffect(() => {
    if (search && !searchIsOpen) {
      setSearchIsOpen(true);
    }
  }, [search]);

  return (
    <div className={styles.container}>
      <div className={`${styles.input} ${searchIsOpen ? styles.isOpen : ''}`}>
        <div className={styles.icon}>
          <FiSearch />
        </div>
        <input
          value={inputSearch}
          placeholder="Rechercher"
          onChange={(e) => handleChange(e)}
        />
        <button
          className={styles.reset}
          onClick={() => clearSearch()}
        >
          <MdClose />
        </button>
      </div>
      {!searchIsOpen
        && <button
          className={styles.toggle}
          onClick={() => setSearchIsOpen(true)}
        >
          <FiSearch />
        </button>
      }

    </div>
  );
}
